import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";
import { Download, Linkedin, Mail } from "lucide-react";
import PDFDownloadModal from "./PDFDownloadModal";

const Footer = ({ contact, pdfUrls }) => {
  const { language, t } = useLanguage();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <footer data-testid="footer" className="bg-slate-900 text-white py-16 md:py-20 mt-16">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            {/* Left side - CTA */}
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold mb-2">
                {t('Interessert i en samtale?', "Interested in a conversation?")}
              </h2>
              <p className="text-slate-400">
                {t('Ta gjerne kontakt.', "Feel free to reach out.")}
              </p>
            </div>

            {/* Right side - Actions */}
            <div className="flex flex-wrap gap-4">
              <Button
                data-testid="download-pdf-btn"
                onClick={() => setShowModal(true)}
                className="bg-sky-600 hover:bg-sky-500 text-white transition-colors duration-300"
              >
                <Download className="w-4 h-4 mr-2" />
                {t('Last ned CV', 'Download CV')}
              </Button>

              <a href={contact.linkedin} target="_blank" rel="noopener noreferrer">
                <Button
                  data-testid="linkedin-btn"
                  variant="outline"
                  className="border-slate-600 text-white hover:bg-slate-800 hover:border-slate-500 transition-colors duration-300"
                >
                  <Linkedin className="w-4 h-4 mr-2" />
                  LinkedIn
                </Button>
              </a>

              <a href={`mailto:${contact.email}`}>
                <Button
                  data-testid="email-btn"
                  variant="outline"
                  className="border-slate-600 text-white hover:bg-slate-800 hover:border-slate-500 transition-colors duration-300"
                >
                  <Mail className="w-4 h-4 mr-2" />
                  {t('Send e-post', 'Send Email')}
                </Button>
              </a>
            </div>
          </div>

          {/* Bottom copyright */}
          <div className="mt-12 pt-8 border-t border-slate-800 text-slate-500 text-sm">
            <p>© {new Date().getFullYear()} Jakob B. Bronebakk. {t('Alle rettigheter reservert.', 'All rights reserved.')}</p>
          </div>
        </div>
      </footer>

      <PDFDownloadModal 
        open={showModal} 
        onOpenChange={setShowModal}
        pdfUrls={pdfUrls}
      />
    </>
  );
};

export default Footer;
